import { AuthContextProvider } from '@backoffice-frontend/authentication'
import { Environment, getEnvironment } from '@backoffice-frontend/environment'
import { loadTranslations } from '@backoffice-frontend/login-view'
import {
  MoiaNotificationProvider,
  PickersUtilsProvider,
  SuspenseLoadingWrapper,
} from '@backoffice-frontend/patterns'
import { Outlet } from 'react-router'

const UserPoolClientIds: Record<Environment, string> = {
  [Environment.test]: 'TODO',
  [Environment.local]: 'TODO',
  [Environment.development]: '4tceko4b34bqhqotu929jrvcsg',
  [Environment.integration]: '4oonhfeob1jp0174hovu6qiijq',
  [Environment.production]: '6lqe375aj51lmunie4n6mip86b',
}

export const Layout = () => {
  loadTranslations()

  return (
    <AuthContextProvider userPoolClientId={UserPoolClientIds[getEnvironment()]}>
      <PickersUtilsProvider>
        <MoiaNotificationProvider>
          <SuspenseLoadingWrapper>
            <Outlet />
          </SuspenseLoadingWrapper>
        </MoiaNotificationProvider>
      </PickersUtilsProvider>
    </AuthContextProvider>
  )
}
